/**
 * cacheConfig.js - Frontend Cache Configuration
 * ==============================================
 * Centralized cache duration settings.
 * All times are in milliseconds.
 *
 * Usage:
 *   import { CACHE_DURATIONS } from '../config/cacheConfig';
 *   const CACHE_DURATION = CACHE_DURATIONS.MODELS;
 */

// ==========================================
// CACHE DURATIONS (in milliseconds)
// ==========================================
export const CACHE_DURATIONS = {
  // Data that changes rarely
  MODELS: 5 * 60 * 1000,        // 5 minutes - model list
  CATEGORIES: 10 * 60 * 1000,   // 10 minutes - category list

  // Data that changes more frequently
  RESULTS: 2 * 60 * 1000,       // 2 minutes - comparison results
  ANALYTICS: 1 * 60 * 1000,     // 1 minute - dashboard stats

  // User-specific data (shorter cache)
  USER_DATA: 30 * 1000,         // 30 seconds - user profile/credits
};

// ==========================================
// HELPER: Convert to readable format
// ==========================================
export const formatDuration = (ms) => {
  if (ms < 60 * 1000) return `${ms / 1000} seconds`;
  return `${ms / 60 / 1000} minutes`;
};

// ==========================================
// DEBUG: Log all cache durations
// ==========================================
export const logCacheConfig = () => {
  if (process.env.NODE_ENV === 'development') {
    console.log('📦 Cache Configuration:');
    Object.entries(CACHE_DURATIONS).forEach(([key, value]) => {
      console.log(`   ${key}: ${formatDuration(value)}`);
    });
  }
};

export default CACHE_DURATIONS;